import WalletTemplatePreviewModalController from '../controllers/modals/preview-modal';
import templateUrl from '../views/modals/preview-modal.tpl.html';

export default function walletTemplatePreviewModalCreator($injector, walletTemplateModel) {
    return $injector.get('$uibModal')
        .open({
            controller: WalletTemplatePreviewModalController,
            controllerAs: 'vm',
            templateUrl,
            backdrop: 'static',
            resolve: {
                templateModel: () => {
                    return walletTemplateModel;
                }
            }
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/helpers/wallet-template-preview-modal-creator.js